import React from 'react'
import {noPropagate} from '@containers/hooks'
import {
  TwActiveUndefined,
  TwActiveWrap,
  TwCheckbox,
  TwText,
  TwWrap
} from './containers'
import IconCheck from './icon-check.svg'
import {CheckboxProps} from './types'

// value has 3 states, true, false and undefined
export const Checkbox = (props: CheckboxProps) => {
  const {text, disabled = false, className, type = 'checkbox'} = props
  const {value = undefined, error = false} = props

  const onChange = (e: React.MouseEvent) => {
    props.onChange?.(!props.value)

    if (props.stopPropagation) {
      noPropagate(e)
    }
  }

  const checkbox = (
    <TwCheckbox
      $active={value === undefined || value}
      $disabled={disabled}
      $error={error}
    >
      <TwActiveWrap>
        {value && <IconCheck className="text-grey-l100-white" />}
        {value === undefined && <TwActiveUndefined />}
      </TwActiveWrap>
    </TwCheckbox>
  )

  return (
    <TwWrap $disabled={disabled} onClick={onChange} className={className}>
      {checkbox}
      {text && (
        <TwText $disabled={disabled} $type={type}>
          {text}
        </TwText>
      )}
    </TwWrap>
  )
}
